export class DemographicSetting {
    public static fromJson = (data: any): DemographicSetting => {
        const dto = new DemographicSetting();
        dto.id = data.id;
        dto.isSelected = data.isSelected;
        dto.notes = data.notes || '';
        return dto;
    }

    public id: number;
    public isSelected: boolean = false;
    public notes: string = '';
}